"use client";

import { c as _c } from "react/compiler-runtime";
import MixedCatalogSection from "../catalog/section";
import FeaturedItemPlacement from "../components/featured-item-placement";
import FloatingCartBar from "../components/floating-cart-bar";
import { getShopPromotionMessages } from "../promotion-messaging";
import React, { useMemo } from "react";
import { FeaturedShopItemState, useShopCatalog } from "@/contexts/shop-catalog-provider";
import { useShopDisplaySettings } from "@/contexts/shop-display-settings-provider";
import type { ShopSection } from "@/lib/shop-links";
import { ShopFulfillmentMethod } from "@/types/enums/shop-fulfillment-method";
import { ShopCartLine } from "@/types/shop";
export function getCatalogInitialSection(initialSection: ShopSection | null | undefined, featured: FeaturedShopItemState): ShopSection | null {
  return featured.status === "pending" || featured.status === "ready" ? null : initialSection ?? null;
}
interface BrowseStageProps {
  initialSection?: ShopSection | null;
  lines: ShopCartLine[];
  onAddLine: (line: ShopCartLine) => void;
  onReplaceLine: (lineId: string, line: ShopCartLine) => void;
  onUpdateQuantity: (lineId: string, quantity: number) => void;
  onRemoveLine: (lineId: string) => void;
  onCheckout: () => void;
  fulfillmentMethod?: ShopFulfillmentMethod | null;
}

/**
 * The "shopping" stage: mixed category catalog + the floating cart bar.
 */
const BrowseStage: React.FC<BrowseStageProps> = t0 => {
  const $ = _c(28);
  const {
    initialSection,
    lines,
    onAddLine,
    onReplaceLine,
    onUpdateQuantity,
    onRemoveLine,
    onCheckout,
    fulfillmentMethod
  } = t0;
  const {
    catalog,
    featured
  } = useShopCatalog();
  const {
    displayStyle
  } = useShopDisplaySettings();
  let t1;
  if ($[0] !== featured || $[1] !== initialSection) {
    t1 = getCatalogInitialSection(initialSection, featured);
    $[0] = featured;
    $[1] = initialSection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const catalogInitialSection = t1;
  let t2;
  if ($[3] !== catalog.promotions || $[4] !== lines) {
    t2 = getShopPromotionMessages(catalog.promotions, lines);
    $[3] = catalog.promotions;
    $[4] = lines;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const promotionMessages = t2;
  const t3 = displayStyle === "STOREFRONT" ? undefined : "motion-preset-slide-up";
  let t4;
  if ($[6] !== onAddLine) {
    t4 = <FeaturedItemPlacement onAddLine={onAddLine} />;
    $[6] = onAddLine;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== catalogInitialSection || $[9] !== lines || $[10] !== onAddLine || $[11] !== onUpdateQuantity) {
    t5 = <MixedCatalogSection initialSection={catalogInitialSection} lines={lines} onAddLine={onAddLine} onUpdateQuantity={onUpdateQuantity} />;
    $[8] = catalogInitialSection;
    $[9] = lines;
    $[10] = onAddLine;
    $[11] = onUpdateQuantity;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== fulfillmentMethod || $[18] !== lines || $[19] !== onCheckout || $[20] !== onRemoveLine || $[21] !== onReplaceLine || $[22] !== onUpdateQuantity || $[23] !== promotionMessages) {
    t7 = <FloatingCartBar lines={lines} onUpdateQuantity={onUpdateQuantity} onRemoveLine={onRemoveLine} onReplaceLine={onReplaceLine} onCheckout={onCheckout} promotionMessages={promotionMessages} fulfillmentMethod={fulfillmentMethod} />;
    $[17] = fulfillmentMethod;
    $[18] = lines;
    $[19] = onCheckout;
    $[20] = onRemoveLine;
    $[21] = onReplaceLine;
    $[22] = onUpdateQuantity;
    $[23] = promotionMessages;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6 || $[26] !== t7) {
    t8 = <div className="pb-24">{t6}{t7}</div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
export default BrowseStage;